import React from 'react'
import PropTypes from 'prop-types'
import { ButtonClose } from 'ui-framework'

/**
 * Form component
 */
export function Form(props) {
  const { children, onCancel, onSubmit } = props

  return (
    <form className="form panel--simple" onSubmit={onSubmit}>
      <ButtonClose onClick={onCancel} right={24} top={8} />
      {children}
    </form>
  )
}

Form.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
}

export default React.memo(Form)
